import React from "react";

import { IViewProps, View } from "core/decorators/View";
import { clamp } from "core/util/MathUtils";
import ProgressCircleViewConfig from "./ProgressCircleViewConfig";

interface IProgressCircleViewProps extends IViewProps<ProgressCircleViewConfig> {
	value?: number; // 0 to 1
}

const CIRCLE_PATH = "M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89";
const CHECKMARK_PATH = "M30 50, L45 66, L73 35";

@View({id: "progress-spinner", configClass: ProgressCircleViewConfig})
export default class ProgressCircleView extends React.PureComponent<IProgressCircleViewProps> {

	public render() {
		const {
			config: {
				backgroundColor,
				checkmarkColor,
				size,
				showCheckmark,
				strokeWidth,
				valueColor
			},
			value
		} = this.props;

		// kinda like the blueprint one but with a default value
		const v = clamp(0, 1, value, 0);

		const circleSize = size && size > 10 ? size : 10;
		const thickness: number = strokeWidth && strokeWidth > 4 ? strokeWidth : 4;
		const offset: number = 280 - 280 * v;

		return (
			<div>
				<svg height={circleSize} width={circleSize} viewBox="0 0 100 100" strokeWidth={thickness}>
					<path
						d={CIRCLE_PATH}
						fill={(showCheckmark && v === 1) ? valueColor : "transparent"}
						stroke={backgroundColor}
					/>
					<path
						d={CIRCLE_PATH}
						fill="transparent"
						pathLength={280}
						strokeDasharray={`280 280`}
						strokeDashoffset={offset}
						strokeLinecap="round"
						stroke={valueColor}
					/>
					{
						v === 1 && (
							<path
								d={CHECKMARK_PATH}
								fill="transparent"
								stroke={checkmarkColor || "#fff"}
							/>
						)
					}
				</svg>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/progressCircle/ProgressCircle.view.tsx